import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { SidebarSection } from 'components/Sidebar/SidebarSection/SidebarSection';
import { SidebarTableContent } from 'components/Sidebar/SidebarTableContent/SidebarTableContent';

export type DocumentPropertiesItem = {
  key: string;
  label: string;
  value: string | ReactNode;
};
export const DocumentProperties = ({ properties }: { properties: Array<DocumentPropertiesItem> }) => {
  const { t } = useTranslation();
  return (
    <SidebarSection header={{ title: t('webedi:sidebar.properties.title') }}>
      <SidebarTableContent
        sections={[
          properties.map((property) => ({
            ...property,
            value: <div className="flex min-h-6 items-center">{property.value}</div>,
          })),
        ]}
      />
    </SidebarSection>
  );
};
